import apiClient from './apiClient';

// Tüm kullanıcıları getir
export const getAllUsers = async () => {
  const response = await apiClient.post('/user/GetAllUsers');
  return response.data.Data.Items || [];
};

// Kullanıcı ekle
export const addUser = async (user) => {
  const response = await apiClient.post('/user/AddUser', user);
  return response.data;
};

// Kullanıcı güncelle
export const updateUser = async (user) => {
  const response = await apiClient.post('/user/UpdateUser', user);
  return response.data;
};

// Kullanıcı sil
export const deleteUser = async (id) => {
  const response = await apiClient.post('/user/DeleteUser', null, { params: { id } });
  return response.data;
};
